import { callCompletionApi } from '@ai-sdk/ui-utils';
import { AiPromptTemplate } from 'src/@types/ai';
import { Session } from 'src/state';
import { axios } from 'src/utils/axios';

export const useAiPromptTemplateChat = () => {
  /**
   * Get response for predefined template and input
   */
  const getResponseForTemplate = ({
    template,
    input,
    context,
  }: {
    template: AiPromptTemplate;
    input: string;
    context: string;
  }) => {
    return new Promise<string>((resolve, reject) => {
      callCompletionApi({
        api: `${axios.defaults.baseURL}/ai/prompt`,
        prompt: input,
        headers: {
          authorization: Session.getToken() || '',
          'Content-Type': 'application/json',
        },
        credentials: 'omit',
        body: {
          messages: [{ role: 'user', content: input }],
          template,
          context,
        },
        onData: () => {},
        setCompletion: () => {},
        setLoading: () => {},
        setError: () => {},
        setAbortController: () => {},
        onResponse: () => {},
        onFinish: (_, completion) => {
          resolve(completion);
        },
        onError: (error) => {
          reject(error);
        },
        fetch: fetch,
        streamProtocol: 'text',
      });
    });
  };

  return {
    getResponseForTemplate,
  };
};
